import React from 'react';
import styles from "../../styles/Features.module.css";
import {Card, CardContent, CardHeader, CardMedia, Typography} from "@mui/material";
import Box from "@mui/material/Box";

const FeatureLargeItem = ({image, subject, primaryText, secondaryText, direction}) => {
    return (
        <Box className={styles.featureLargeItem} style={{flexDirection: (direction === 'right') ? 'row-reverse' : 'row'}}>
            <Box className={styles.largeFeatureItemImageContainer}>
                <img src={image} alt={subject} className={styles.largeItemImg}/>
            </Box>
            <Box className={styles.largeFeatureItemText}>
                <Typography variant="h4" component="h4" gutterBottom>
                    {subject}
                </Typography>

                <Box className={styles.text}>
                    {primaryText}
                </Box>

                <Box className={styles.text}>
                    {secondaryText}
                </Box>
            </Box>
        </Box>
    );
};

export default FeatureLargeItem;

